export default __webpack_public_path__ + "static/media/background.bd50077d.jpg";